import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Wallet04 = function Wallet04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M20 9.5V7.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C18.4802 4 17.9201 4 16.8 4H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 5.5198 2 6.08 2 7.2v9.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 20 4.08 20 5.2 20h11.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C20 18.4802 20 17.9201 20 16.8v-2.3M15 12c0-.4647 0-.697.0384-.8902a2 2 0 0 1 1.5714-1.5714C16.803 9.5 17.0353 9.5 17.5 9.5h2c.4647 0 .697 0 .8902.0384a2 2 0 0 1 1.5714 1.5714C22 11.303 22 11.5353 22 12s0 .697-.0384.8902a2 2 0 0 1-1.5714 1.5714c-.1932.0384-.4255.0384-.8902.0384h-2c-.4647 0-.697 0-.8902-.0384a2 2 0 0 1-1.5714-1.5714C15 12.697 15 12.4647 15 12"
    })
  }));
};
export default Wallet04;